import {
  getLawsuitsByProjectIdQuery,
  setLawsuitToLandIdsMutation,
  createLawsuitMutation,
  deleteLawsuitMutation,
  updateLawsuitMutation
} from '~graphql/lawsuits.graphql'

export default {
  getLawsuitsByProjectId({ state, dispatch }, projectId) {
    return dispatch('getItems', {
      state,
      modelName: 'projectLawsuits',
      loader: 'projectLawsuits:get',
      query: getLawsuitsByProjectIdQuery,
      resultPath: 'lawsuits.nodes',
      variables: {
        projectId
      }
    })
  },
  setLawsuitToLandIds({ state, dispatch }, payload) {
    return dispatch('createItem', {
      item: payload,
      state,
      loader: 'lawsuitSet:create',
      mutation: setLawsuitToLandIdsMutation,
      resultPath: 'setLawsuit.ids'
    })
  },
  createLawsuit({ state, dispatch }, lawsuit) {
    return dispatch('createItem', {
      item: lawsuit,
      state,
      modelName: 'selectedLawsuit',
      addTo: ['projectLawsuits'],
      loader: 'lawsuit:create',
      mutation: createLawsuitMutation,
      resultPath: 'createLawsuit.lawsuit'
    })
  },
  updateLawsuit({ state, dispatch }, lawsuit) {
    return dispatch('createItem', {
      item: lawsuit,
      state,
      modelName: 'selectedLawsuit',
      addTo: ['projectLawsuits'],
      loader: 'lawsuit:update',
      mutation: updateLawsuitMutation,
      resultPath: 'updateLawsuit.lawsuit'
    })
  },
  deleteLawsuit({ state, dispatch }, id) {
    return dispatch('deleteItem', {
      id,
      state,
      modelName: 'selectedLawsuit',
      removeFrom: ['projectLawsuits'],
      loader: 'lawsuit:delete',
      mutation: deleteLawsuitMutation
    })
  },
  setSelectedLawsuit({ state, commit }, lawsuit) {
    commit('SET_ITEM', {
      state,
      item: lawsuit,
      modelName: 'selectedLawsuit'
    })
  }
}
